var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { PersonPlus } from "@reverb-ui/icons-react";
import { Button, FormControl, HStack, Input, useToast } from "@reverb-ui/react";
import React, { useContext, useState } from "react";
import { UsersTabContext } from "@/features/first-access/presentation/context-api/users-tab-provider";
import { useForm } from "react-hook-form";
var emailValidator = {
    required: true,
    pattern: /^[a-z0-9.]+@[a-z0-9]+\.[a-z]/i,
};
export var SearchUsersInput = function (_a) {
    var clientRockId = _a.clientRockId, locationId = _a.locationId;
    var toast = useToast();
    var _b = useContext(UsersTabContext), searchForEmployees = _b.searchForEmployees, createClientEmployee = _b.createClientEmployee, bindEmployeeWithClient = _b.bindEmployeeWithClient;
    var _c = useForm(), register = _c.register, handleSubmit = _c.handleSubmit, clearErrors = _c.clearErrors, reset = _c.reset, errors = _c.formState.errors;
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    var addUser = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var searchEmail, limit, employees, employeeSerched;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    searchEmail = values.searchEmail;
                    limit = 1;
                    setLoading(true);
                    return [4 /*yield*/, searchForEmployees(searchEmail, limit)];
                case 1:
                    employees = _a.sent();
                    if (!!employees.length) return [3 /*break*/, 3];
                    if (!locationId) {
                        toast({
                            status: "error",
                            title: "Error bind employee with client",
                            duration: 5000,
                        });
                        setLoading(false);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, createClientEmployee(clientRockId, searchEmail, locationId)];
                case 2:
                    _a.sent();
                    setLoading(false);
                    return [2 /*return*/];
                case 3:
                    employeeSerched = employees[0];
                    return [4 /*yield*/, bindEmployeeWithClient(clientRockId, employeeSerched.rockId)];
                case 4:
                    _a.sent();
                    setLoading(false);
                    handleClose();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleClose = function () {
        reset();
        clearErrors();
    };
    return (React.createElement("form", null,
        React.createElement(HStack, { spacing: 3, justify: "flex-start", pb: 3 },
            React.createElement(FormControl, { isRequired: true, isInvalid: !!errors.searchEmail },
                React.createElement(Input, __assign({ type: "email" }, register("searchEmail", emailValidator), { placeholder: "Insert an email valid (ex: email@example.com)" }))),
            React.createElement(Button, { onClick: handleSubmit(addUser), colorScheme: "blue", leftIcon: React.createElement(PersonPlus, { color: "white" }), isLoading: loading }, "Add user"))));
};
